import React, { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import '../styling/componentStyles.css'

interface DropDownProps{
  item: Array<string>;
  label: string;
  name: string;
  handleToUpdate: Function;
}

export const Dropdown: React.FC<DropDownProps> = (props: DropDownProps) =>{
  const{
      label, item, handleToUpdate, name,
  } = props;

  const [profession, setProfession] = useState(item[0])
    

    const handleChange = (event: any) => {
      setProfession(event.target.value);
      handleToUpdate(event.target.value)
    }

        return(
        <div className='dropDown' id={label}  > 
        <div className="dropDownLabel">
          <label>{label}</label>
        </div>
        <FormControl variant="outlined" id='formControl'>
          <Select
            id='dropDownSelect'
            className={name}
            value={profession}
            onChange={handleChange} >
          
            { item.map((element: any) => (
                <MenuItem id='menuitem' key={element} value={element} >{element}</MenuItem>
            ))}
          </Select>
      </FormControl>
  
      </div>           
        )
    }
    

export default Dropdown